@if (facade.error()) {
<div class="error-container h-100">
  <div class="error-content">
    <mat-icon>error</mat-icon>
    <h2>{{ 'shared.api.errors.default' | translate }}</h2>
  </div>
</div>
} @else {
<div class="dashboard-container container gap-2">
  <div class="filter-container p-3 d-flex justify-content-between align-items-center">
    <div class="search-wrapper">
      <label class="search-label mb-1">{{ 'shared.general.labels.quick_search' | translate }}</label>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'app.settings.user_management.search_label' | translate }}</mat-label>
        <input matInput [placeholder]="'app.settings.user_management.search_placeholder' | translate"
          [formControl]="searchControl" />
        @if (searchControl.value) {
        <button mat-icon-button matSuffix class="me-2" (click)="searchControl.reset()">
          <mat-icon>close</mat-icon>
        </button>
        } @else {
        <mat-icon matSuffix class="icon-md">search</mat-icon>
        }
        <mat-hint>{{ 'app.settings.user_management.search_hint' | translate }}</mat-hint>
      </mat-form-field>
    </div>
    @if(currentUser()?.hasPermission(permissions.USER_CREATE)) {
    <button mat-raised-button color="primary" [routerLink]="'/settings/users/add'">
      <mat-icon>add</mat-icon>
      {{ 'app.settings.user_management.add_user' | translate }}
    </button>
    }
  </div>
  <div class="table-container">
    <app-users-table></app-users-table>
  </div>
</div>
}